import React from 'react';
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  TextField,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { calculateAge } from '../../utility/general';

const VitalsDrawer = ({ open, onClose, initialData }) => {
  const VitalField = ({ label, value, placeholder = "Not Available" }) => (
    <TextField
      label={label}
      value={value || ''}
      placeholder={placeholder}
      fullWidth
      InputProps={{
        readOnly: true,
      }}
      sx={{ mb: 2 }}
    />
  );


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '400px', padding: '20px' }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6">Patient's Vital</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 3 }} />
      
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <VitalField 
          label="Temperature" 
          value={initialData?.temperature ? `${initialData.temperature}°C` : ''}
          placeholder="35 - 39°C"
        />

        <VitalField 
          label="Age" 
          value={calculateAge(initialData?.patient?.dateOfBirth)}
          placeholder="Not Available"
        />

        <VitalField 
          label="Heart Rate" 
          value={initialData?.heartRate}
          placeholder="60-100 bpm"
        />

        <VitalField 
          label="Blood Pressure" 
          value={initialData?.bloodPressure}
          placeholder="120/80 mmHg"
        />

        <VitalField 
          label="Respiratory Rate" 
          value={initialData?.respiratoryRate}
          placeholder="12-20 breaths/min"
        />

        <VitalField 
          label="Weight" 
          value={initialData?.patient?.weight ? `${initialData.patient.weight} kg` : ''}
          placeholder="Weight in kg"
        />

        <VitalField 
          label="Assigned Doctor" 
          value={initialData?.doctor ? `Dr. ${initialData.doctor.firstName} ${initialData.doctor.lastName}` : ''}
          placeholder="No doctor assigned"
        />

        <TextField
          label="Additional Note"
          multiline
          rows={4}
          value={initialData?.additionalNote || ''}
          placeholder="No additional notes"
          fullWidth
          InputProps={{
            readOnly: true,
          }}
        />

        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Last Updated: {initialData?.updatedAt ? new Date(initialData.updatedAt).toLocaleString() : 'Not available'}
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default VitalsDrawer;